<template>
  <div>
    <BaseTitle :title="$t(edit ? 'form.course_edit' : 'form.course_create')" />

    <form @submit.prevent="submit">
      <v-card class="mb-8 pa-8">
        <form-group :name="$t('form.name')" :validator="$v.form.name">
          <template slot-scope="{ attrs }">
            <v-text-field
              v-model="form.name"
              :disabled="form.used == true"
              v-bind="attrs"
              :label="$t('form.name')"
              @input="$v.form.name.$touch()"
              @blur="$v.form.name.$touch()"
            />
          </template>
        </form-group>
        <form-group :name="$t('form.desc')" :validator="$v.form.description">
          <template slot-scope="{ attrs }">
            <v-textarea
              v-model="form.description"
              v-bind="attrs"
              :label="$t('form.desc')"
              @input="$v.form.description.$touch()"
              @blur="$v.form.description.$touch()"
            />
          </template>
        </form-group>
      </v-card>
      <div class="d-flex justify-end align-center">
        <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="backToList">{{ $t(edit ? 'back' : 'cancel') }}</v-btn>
        <v-btn color="primary" :loading="loading" class="btn-primary-custom" type="submit">{{ $t(edit ? 'save' : 'submit') }}</v-btn>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { required, maxLength } from 'vuelidate/lib/validators';
import BaseTitle from '@/components/base/Title';
import onlyWord from '@/validators/onlyWord';
import wordPunctuation from '@/validators/wordPunctuation';

export default {
  name: 'CreateEditCourse',
  components: {
    BaseTitle
  },
  validations: {
    form: {
      name: { required, onlyWord, maxLength: maxLength(255) },
      description: { required, wordPunctuation, maxLength: maxLength(255) }
    }
  },
  computed: {
    ...mapGetters({
      user: 'Auth/user'
    })
  },
  watch: {
    user: {
      deep: true,
      immediate: true,
      handler: function(value) {
        this.form.schoolId = value.schoolId;
      }
    }
  },
  data: () => ({
    edit: false,
    loading: false,
    form: {
      name: '',
      description: '',
      schoolId: '',
      used: ''
    }
  }),
  methods: {
    getData() {
      this.$store
        .dispatch(
          `CourseSchool/${this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null ? 'fetchDetail' : 'fetchDetailLite'}`,
          this.$route.params.id
        )
        .then(res => Object.keys(this.form).forEach(form => (this.form[form] = res[form])))
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e));
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return false;
      }

      this.loading = true;
      const payload = { ...(this.edit ? { id: this.$route.params.id } : null), ...this.form };
      this.$store
        .dispatch(
          `CourseSchool/${
            (this.edit && this.user.cerdasTypeId === 2) || (this.edit && this.user.cerdasTypeId === null)
              ? 'update'
              : (!this.edit && this.user.cerdasTypeId === 2) || (!this.edit && this.user.cerdasTypeId === null)
              ? 'save'
              : this.edit && this.user.cerdasTypeId === 1
              ? 'updateLite'
              : 'saveLite'
          }`,
          payload
        )
        .then(() => {
          this.$router.push({ name: this.edit ? 'CourseUpdateSuccess' : 'CourseSuccess' });
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => (this.loading = false));
    },
    backToList() {
      this.$router.push({ name: 'CourseIndex' });
    }
  },
  created() {
    if (this.$route.params.id) {
      this.edit = true;
      this.getData();
    }
  }
};
</script>
